import {ParsedUrlQuery, default as queryString} from "querystring";
import {KeycloakTokenParsed} from "keycloak-js";
import {ExtendedTokenParsed} from "../context/AuthContext";
import {
    ConflictRequestError, InvalidRequestError, NotFoundRequestError, ResponseError,
    UnexpectedError
} from "../type/index";

export const queryParams = (search:string): ParsedUrlQuery => {

    if (search.startsWith('?')) {
        search = search.slice(1);
    }

    return queryString.parse(search);
};


export const getUserFromToken = (token: Keycloak.KeycloakInstance) => {
    let name: string | undefined  = '';
    if (token !== undefined) {
        const parsed: KeycloakTokenParsed | undefined = token.tokenParsed;

        if (parsed !== undefined) {
            const extendedToken: ExtendedTokenParsed = (parsed as ExtendedTokenParsed);
            name = (extendedToken.name !== undefined ? extendedToken.name : extendedToken.preferred_username);
        }
    }
    return name;
};


export const hasRole = (keycloak: Keycloak.KeycloakInstance, role:string): boolean => {
    return (keycloak.hasRealmRole(role) || keycloak.hasResourceRole(role));
};


export const getResponseError = (status: number): ResponseError  => {

    let res: ResponseError;
    switch (status) {
        case 400:
            res = new InvalidRequestError();
            break;
        case 404:
            res = new NotFoundRequestError();
            break;
        case 409:
            res = new ConflictRequestError();
            break;
        case 500:
            res = new UnexpectedError();
            break;
        default:
            res = new UnexpectedError();
            break;
    }

    return res;
};


const emailPattern = '(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])';

export const validateEmail = (email: string): boolean => {
    const regExp = new RegExp(emailPattern);
    return regExp.test(email);
};


export const consentMap: Record<string, string> = {
    consentForm: 'Consenso Dati Anamnestici',
    consentGen: 'Consenso Test Genetici'
};

export const consentValue = (value: boolean) => {
    return (value?'Acconsento': 'Non Acconsento');
};

export function pick<T, K extends keyof T>(obj: T, keys: K[]): Pick<T, K> {
    let newObj = {} as Pick<T, K>;
    for (const key of keys) {
        newObj[key] = obj[key];
    }
    return newObj;
};